module.exports = "//public.zight.com/packs/media/images/checkmark-7454b119285255710c22968faf12fbee.svg";